module.exports = __webpack_public_path__ + "img/15.46c6f560.jpg";